var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-wrap items-center membership-layout-container"},[_c('div',{staticClass:"mr-2"},[_c('span',{staticClass:"text-sm",staticStyle:{"color":"grey"}},[_vm._v(" "+_vm._s(_vm.activeElement.value.name)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }